import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { UpdateAlias$ } from "../schemas/schemas_0";
export { $Command };
export class UpdateAliasCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "UpdateAlias", {})
    .n("KMSClient", "UpdateAliasCommand")
    .sc(UpdateAlias$)
    .build() {
}
